<template>
<div>
  <!-- <pre v-text='selectedAppointments' /> -->
<transition name='fade' appear >
<v-toolbar extended fixed dark flat top
  extension-height='28' color='primary'
  v-if='selectedAppointments.length > 0'
  style='z-index:15;'
  :style="{ top: topOffset }" >

      <v-btn @click='$emit("deselect")' :icon='$vuetify.breakpoint.xs' flat small dark >
        <v-icon >close</v-icon>
        <span class='hidden-xs-only' > {{ $t('buttons.deselect') }}</span>
      </v-btn>

      <v-spacer></v-spacer>
      <!-- <v-btn dark flat small outline class='mr-0 ml-0'
        @click='dialogs.edit = true' >
          <v-icon small dark>edit</v-icon> {{ $t('buttons.edit') }}</v-btn> -->
      <!-- {{permissionsCanBulkAddCodes}}
      {{ normalizedPractitionerId(selectedAppointments[0]) }}
      {{ meId }} -->
      <v-btn dark flat small outline class='mr-0'
        :disabled='permissionsCanBulkAddCodes === false'
        @click='codeTouch++; dialogs.codes = true' >
        <v-icon small dark>add</v-icon> {{ $t('buttons.codes') }}
      </v-btn>

      <!-- @click='dialogs.invoice = true' -->
      <v-btn dark flat small outline class='mr-0'
        :disabled='(clientIds && clientIds.length > 1) || permissionsCanCreateInvoice === false'
        @click='launchQuickInvoiceDialog(invoiceOptions)' >
        <v-icon small dark>add</v-icon> {{ $t('buttons.invoices') }}
      </v-btn>

      <v-btn dark flat small outline class='mr-0'
        :disabled='(clientIds && clientIds.length > 1) || (spaceIds && spaceIds.length > 1) || permissionsCanBulkAddPayment === false'
        @click='launchAppointmentPaymentDialog(paymentOptions)' >
          <v-icon small dark>add</v-icon>
          {{ $t('buttons.payments') }}
      </v-btn>

      <template slot='extension' v-if='selectedAppointments && selectedAppointments.length > 0' >
          <v-menu >
            <template v-slot:activator="{ on }">
              <v-btn small flat
                v-on='on' slot='activator'
                class='ma-0 pl-0 mr-2 mb-3 white--text'
                :class='{"ml-0": $vuetify.breakpoint.xs, "ml-3": $vuetify.breakpoint.smAndUp}' >
                {{ $tc('toolbar.extension', selectedAppointments.length, {n: selectedAppointments.length}) }}
              <v-icon>arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <v-list dense three-line subheader class='pa-0' >
              <v-subheader class='overline py-0 grey lighten-4' >
                Selected appointments

              </v-subheader>
              <v-divider/>
              <appointment-list-item with-tags
                v-for='appointment in selectedAppointments'
                :key='appointment.id'
                :with-action='false'
                with-status-chips
                :with-color-coding='false'
                :appointment='appointment' />
            </v-list>
          </v-menu>
        <v-spacer/>
        <!-- With {{selectedAppointments.length}} selected appointments -->
        <!-- <v-chip class='mt-0 mb-3' outline small v-if='client && client.id' color='white' >
          {{ client.first_name }} {{ client.last_name }}
        </v-chip> -->
        <space-faces style='margin-top:-10px;' :space-ids='spaceIds' v-if='spaceIds && spaceIds.length > 0' />
        <v-divider vertical class='mx-2' />
        <practitioner-faces style='margin-top:-10px;' :practitioner-ids='practitionerIds' />
      <!-- <v-chip v-for='spaceId in spaceIds' :key='spaceId' >{{spaceId}}</v-chip> -->
      </template>
</v-toolbar>
</transition>

<!-- <v-dialog v-model='dialogs.payments' :fullscreen="$vuetify.breakpoint.xs" >
  <v-toolbar :color='themeColor' dense dark >
    <v-toolbar-title>
      {{ $t('dialogs.titles.payments') }}
    </v-toolbar-title>
    <v-spacer ></v-spacer>
    <v-btn @click='dialogs.payments = false' icon >
      <v-icon>close</v-icon>
    </v-btn>
  </v-toolbar>
  <create-transaction
    :loading='paymentRequest.loading'
    :appointments='selectedAppointments' >
  </create-transaction>
</v-dialog> -->

<v-dialog v-model='dialogs.codes' :fullscreen="$vuetify.breakpoint.xs" >
  <v-toolbar :color='themeColor' dense dark >
    <v-toolbar-title>{{ $t('dialogs.titles.codes') }}
    </v-toolbar-title>
    <v-spacer ></v-spacer>
    <v-btn @click='dialogs.codes = false' icon >
      <v-icon>close</v-icon>
    </v-btn>
  </v-toolbar>
  <bulk-add-codes
    @saved='$emit("codes:created")'
    @close='dialogs.codes = false'
    :with-title='true'
    :with-done='true'
    :touch='codeTouch'
    :appointment-ids='selectedAppointmentIds' >
  </bulk-add-codes>
</v-dialog>
</div>
</template>

<script>
import CreateTransaction from '@/components/appointment/actions/CreateTransaction'
import BulkAddCodes from '@/components/appointment/BulkAddCodes'
import AppointmentListItem from '@/components/appointment/AppointmentListItem'
import SpaceFaces from '@/components/lists/SpaceFaces.vue'
import PractitionerFaces from '@/components/lists/PractitionerFaces.vue'

export default {
  name: 'BulkActions',
  components: {
    CreateTransaction,
    BulkAddCodes,
    SpaceFaces,
    PractitionerFaces,
    AppointmentListItem
  },
  props: {
    selectedAppointments: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      dialogs: {
        edit: false,
        invoice: false,
        payments: false,
        codes: false,
        invoiceSuccess: false
      },
      reqs: {
        invoice: 'bulk-invoice-request',
        payment: 'bulk-payment-requets'
      },
      request: {
        resource: 'ag.practitioner.statement'
      },
      codeTouch: 1,
      newInvoiceResult: null
    }
  },
  computed: {
    numGloballySelectedAppointments () {
      if (this.selectedAppointments && this.selectedAppointments.length > 0) {
        return this.selectedAppointments.length
      }
      return 0
    },
    client () {
      if (this.clientId) {
        return this.getClientById(this.clientId)
      }
      return null
    },
    clientId () {
      if (this.clientIds && this.clientIds.length === 1) {
        return this.selectedAppointments[0].client
      }
      return null
    },
    clientIds () {
      let ids = new Set()
      if (this.numGloballySelectedAppointments > 0) {
        this.selectedAppointments.forEach((i) => { ids.add(i.client) })
      }
      return Array.from(ids)
    },
    relationship () {
      if (this.relationshipId) {
        return this.getRelationById(this.relationshipId)
      }
      return null
    },
    relationshipId () {
      if (this.relationshipIds && this.relationshipIds.length === 1) {
        return this.selectedAppointments[0].computed_relationship_id
      }
      return null
    },
    relationshipIds () {
      let ids = new Set()
      if (this.numGloballySelectedAppointments > 0) {
        this.selectedAppointments.forEach((i) => { ids.add(i.computed_relationship_id) })
      }
      return Array.from(ids)
    },
    practitionerIds () {
      let ids = new Set()
      if (this.numGloballySelectedAppointments > 0) {
        this.selectedAppointments.forEach((i) => { ids.add(i.practitioner) })
      }
      return Array.from(ids)
    },
    spaceIds () {
      let ids = new Set()
      if (this.numGloballySelectedAppointments > 0) {
        this.selectedAppointments.forEach((i) => {
          if (i.space) { ids.add(i.space) }
          if (i.service_id) { ids.add(i.service_id) }
        })
      }
      return Array.from(ids)
    },
    appointmentIds () {
      let ids = new Set()
      if (this.numGloballySelectedAppointments > 0) {
        this.selectedAppointments.forEach((i) => { ids.add(i.id) })
      }
      return ids
    },
    invoiceOptions () {
      return {
        appointments: this.selectedAppointments,
        relationship: this.relationship
      }
    },
    paymentOptions () {
      return {
        appointments: this.selectedAppointments
      }
    },
    topOffset () {
      if (this.appPlatform === 'ios') {
        return '24px'
      }
      return '0px;'
    },
    invoiceRequest () {
      return this.$store.getters.getRequestById(this.reqs.invoice, true)
    },
    invoiceRequestStatus () {
      return this.invoiceRequest.status
    },
    paymentRequest () {
      return this.$store.getters.getRequestById(this.reqs.payment, true)
    },
    paymentRequestStatus () {
      return this.paymentRequest.status
    },
    loading () {
      return (
        this.invoiceRequest.loading
      )
    },
    selectedAppointmentIds () {
      return this.selectedAppointments.map((appt) => {
        return appt.id
      })
    }
  },
  watch: {
    invoiceRequestStatus () {
      if (this.invoiceRequestStatus === 201) {
        this.$emit(
          'invoice:created',
          this.invoiceRequest.result.data
        )
        this.dialogs.invoice = false
      }
    },
    paymentRequestStatus () {
      if (this.paymentRequestStatus === 201) {
        this.dialogs.payments = false
        this.$emit(
          'payment:created',
          this.paymentRequest.result.data
        )
      }
    },
    selectedAppointments: {
      immediate: true,
      handler () {
        if (this.selectedAppointments) {
          this.globalSelectedAppointments = this.selectedAppointments
        }
      }
    }
  },
  methods: {
    getStatement (clientId) {
      if (clientId && this.selectedAppointmentIds && this.selectedAppointmentIds.length > 0) {
        this.request.resourceId = clientId
        let apptIds = this.selectedAppointmentIds.join(',')
        this.request.params = {
          appointments: apptIds
        }
        this.$request('get', this.request)
      }
    },
    createInvoice () {
      //   consider these fields:
      //   date: moment(this.invoice.date).format('YYYY-MM-DD'),
      //   due_date: moment(this.invoice.due_date).format('YYYY-MM-DD'),
      //   invoice_period_from: moment(this.activeDateRange.from).format('YYYY-MM-DD'),
      //   invoice_period_to: moment(this.activeDateRange.to).format('YYYY-MM-DD')
      let payload = {
        customer_id: this.clientId,
        practitioner_id: this.me.id,
        appointments: this.selectedAppointmentIds
      }
      let data = JSON.stringify(payload)
      this.$invoiceguru
        .resource('invoices')
        .id(this.reqs.invoice)
        .create(data)
    }
  },
  i18n: {
    messages: {
      en: {
        toolbar: {
          extension: '{n} selected appointments | {n} selected appointment | {n} selected appointments'
        },
        messages: {
          noneselected: 'No appointments selected. Please choose some appointments first'
        },
        buttons: {
          setprice: 'Edit',
          codes: 'Codes',
          invoices: 'Invoice',
          payments: 'Payments',
          deselect: 'Deselect all',
          createinvoice: 'Create Invoice'
        },
        dialogs: {
          titles: {
            codes: 'Add diagnosis codes',
            invoice: 'Create an invoice with these appointments',
            payments: 'Add Payments',
            setprice: 'Set price'
          }
        }
      }
    }
  }
}
</script>

<style>
.v-snack.wide .v-snack__wrapper { max-width:90%; }
</style>



// WEBPACK FOOTER //
// BulkActions.vue?1f2e5069